module.exports = __webpack_public_path__ + "static/media/Alex Hunter Headshot.b3708109.jpeg";